import { discoArrayToProductImageStruct } from "helpers/product-image-helpers";

/**
 * Maps the product data to the Google schema.
 * @param {Object} productData - The raw product data.
 * @param {Object} reviews - Customer review data
 */
export function createProductSchemaForSEO(staticProduct, productPrice, reviews) {
  try {
    const description = `
    ${staticProduct?.stylistNotes?.replace(/<\/?[^>]+(>|$)/g, "")}. 
    ${staticProduct?.productDetails?.replace(/<\/?[^>]+(>|$)/g, "").trim()}. 
    ${staticProduct?.length ? `Length: ${staticProduct?.length}` : ""}.
  `.trim();

    const frontImageUrl = discoArrayToProductImageStruct(staticProduct?.images ?? [])?.front?.["1080x"] ?? "";
    const sizes = staticProduct?.skus?.map(o => o?.sizeDisplayText) ?? [];
    const colors = staticProduct?.additionalAttributes?.find(o => o?.id === "color")?.values ?? [];

    // Sort and structure the top 10 reviews (can add more as required)
    const sortedReviews = [...(Array.isArray(reviews?.data) ? reviews.data : [])]
      .sort((a, b) => new Date(b?.uploadedAt) - new Date(a?.uploadedAt))
      .slice(0, 10)
      .map(review => ({
        "@type": "Review",
        "name": typeof review?.caption === "string" && review?.caption?.trim() ? review?.caption : "User review",
        "datePublished": new Date(review?.uploadedAt),
        "reviewBody": review?.content ?? "",
        "reviewRating": {
          "@type": "Rating",
          "worstRating": 1,
          "bestRating": 5,
          "ratingValue": (review?.rating / 2).toFixed(1), // Convert to a 1-5 scale to allign with Google
        },
        "author": {
          "@type": "Person",
          "name": typeof review?.firstName === "string" && review?.firstName?.trim() ? review?.firstName : "Anonymous",
        },
      }));

    const schema = {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": staticProduct?.displayName,
      "image": `https://pc-ap.rtrcdn.com/${frontImageUrl}`,
      "description": description,
      "sku": staticProduct?.productId,
      "brand": {
        "@type": "Brand",
        "name": staticProduct?.designerDisplayName,
      },
      "offers": {
        "@type": "Offer",
        "url": staticProduct?.pdpUrl ?? "",
        "priceCurrency": "USD",
        "availability":
          staticProduct?.stage === "PUBLISHED" ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
        "price": productPrice,
      },
      "category": staticProduct?.category,
      "size": sizes?.join(", "),
      "color": colors?.join(", "),
      "audience": {
        "@type": "PeopleAudience",
        "suggestedGender": "female",
        "suggestedAge": ["adult"],
      },
    };

    if (Array.isArray(sortedReviews) && sortedReviews.length > 0) {
      schema["review"] = sortedReviews;
    }

    if (
      Number.isInteger(reviews?.count) &&
      reviews.count > 0 &&
      Number.isInteger(reviews?.averageRating) &&
      reviews.averageRating > 0
    ) {
      schema["aggregateRating"] = {
        "@type": "AggregateRating",
        "ratingValue": (reviews?.averageRating / 2).toFixed(1),
        "bestRating": 5,
        "reviewCount": reviews?.count,
      };
    }
    return JSON.stringify(schema);
  } catch (error) {
    console.error("Error creating product schema for SEO:", error);
  }
}
